export default function MobileListItem({
  title,
  subtitle,
  onClick,
  selectable = false,
  selected = false,
}) {
  return (
    <li>
      <button
        type="button"
        onClick={onClick}
        aria-pressed={selectable ? selected : undefined}
        className="flex w-full min-h-[44px] items-center gap-3 px-4 py-3 text-left hover:bg-monao active:bg-primary/20"
      >
        {selectable ? (
          <input
            type="checkbox"
            checked={selected}
            readOnly
            tabIndex={-1}
            aria-hidden="true"
            className="h-5 w-5 shrink-0 rounded border-primary/50 bg-monao accent-primary"
          />
        ) : null}
        <div className="min-w-0 flex-1">
          <div className="truncate font-medium text-laranjinha">{title}</div>
          {subtitle ? (
            <div className="truncate text-sm text-laranjinha/60">{subtitle}</div>
          ) : null}
        </div>
        {selectable ? null : (
          <span className="shrink-0 text-primary" aria-hidden="true">
            ›
          </span>
        )}
      </button>
    </li>
  );
}
